import * as React from 'react';
import * as I18nAPI from '../api/i18n';
import { DebugMode } from '../contexts';
export function i18nSport({ sport, label }, debug) {
    const translation = I18nAPI.translate('sports', sport);
    if (debug) {
        return sport + (translation ? '*' : '');
    }
    return translation || label || sport;
}
const Sport = props => {
    const debugEnabled = React.useContext(DebugMode);
    return React.createElement(React.Fragment, null, i18nSport(props, debugEnabled));
};
export default Sport;
//# sourceMappingURL=Sport.js.map